<template>
  <div class="loginPlane" v-if="loginShow">
    <!-- <div class="left">
      <img src="../assets/images/home/loginBG.png" />
    </div> -->
    <div class="login">
      <div>
        <i @click="closeLogin" class="el-icon-close"></i>
      </div>
      <div class="logo">
        <img :src="logo" />
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('LoginObj.LoginAndPassword')" name="first"></el-tab-pane>
        <el-tab-pane :label="$t('LoginObj.LoginCode')" name="second"></el-tab-pane>
      </el-tabs>
      <el-form :model="formList" ref="formList" :rules="rules">
        <el-form-item prop="username">
          <div class="leftItem">
            <div class="icon-bk">
              <i class="el-icon-user left-icon"></i>
            </div>
            <el-input :placeholder="$t('LoginObj.PleaseNumber')" v-model="formList.mobile"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="password"  v-if="activeName === 'first'">
          <div class="leftItem">
            <div class="icon-bk">
              <i class="el-icon-lock left-icon"></i>
            </div>
            <el-input type="password" :placeholder="$t('LoginObj.PleasePassword')" v-model="formList.password"></el-input>
          </div>
        </el-form-item>

        <el-form-item prop="captcha" :rules="[{required: true, message: $t('LoginObj.PleaseCode')}]"  v-if="activeName === 'first'">
          <div class="rightItem">
            <el-input
              class="code-input"
              :placeholder="$t('LoginObj.PleaseCode')"
              v-model="formList.captcha"
              maxlength="10"
            ></el-input>
            <img class="verificationCode" :src="'data:image/png;base64,'+captchaImg" />
          </div>
          <div class="refresh" @click="getImgCodes">
            <span>{{$t('LoginObj.Change')}}</span>
            <i v-if="!imgCodeLoad" class="el-icon-refresh refresh1"></i>
            <i v-else class="el-icon-loading refresh1"></i>
          </div>
        </el-form-item>

        <el-form-item prop="captcha" :rules="[{required: true, message: $t('LoginObj.PleaseCode')}]"  v-if="activeName !== 'first'">
          <div class="icon-bk">
            <i class="el-icon-postcard left-icon"></i>
          </div>
          <div class="rightItem">
            <el-input
              class="code-input"
              :placeholder="$t('LoginObj.PleaseCode')"
              v-model="formList.captcha"
              maxlength="10"
            ></el-input>
            <el-button v-if='isSendCode' @click='verificationCodeEvent' class='verificationCodeBtn' :disabled='isSendCode'>{{this.isNumber+'s'+$t('LoginObj.Reacquire')}}</el-button>
            <el-button v-else @click='verificationCodeEvent' class='verificationCodeBtn' :disabled="formList.mobile === '' || isSendCode">{{$t('LoginObj.GetVerificationCode')}}</el-button>
          </div>
        </el-form-item>

        <div class="handleBox">
          <el-button class="handle" @click="loginEvent">{{$t('LoginObj.LogIn')}}</el-button>
        </div>

        <div class="foot-login">
          <span>
            {{$t('LoginObj.NoAccount')}}?
            <a class="curter" style="color:DarkOrange;" @click="toRegist(1)">{{$t('LoginObj.SignUpNow')}}</a>
          </span>
          <span @click="toRegist(2)" class="forget-password curter">{{$t('LoginObj.ForgotPassword')}}?</span>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getImgCode, userLogin, messageCodeLogin, messageAuthentication, queryMobile } from '@/api/login.js'
export default {
  name: 'loginPlane',
  props: ['loginShow', 'logo'],
  watch: {
    loginShow (newName, oldName) {
      if (newName) {
        this.getImgCodes()
      }
    }
  },
  data () {
    var validateUsername = (rule, value, callback) => {
      if (this.formList.mobile === '') {
        callback(new Error('请输入手机号'))
      } else if (
        this.formList.mobile.match(/^1[34578]\d{9}$/) === null
      ) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (this.formList.password === '') {
        callback(new Error(this.$t('LoginObj.PleasePassword')))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (this.formList.password === '') {
        callback(new Error('请再次输入密码'))
      } else if (this.formList.password2 !== this.formList.password) {
        console.log(value, this.formList.password)
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      formList: {
        mobile: '',
        captcha: '',
        password: '',
        password2: ''
      },
      rules: {
        mobile: [{ validator: validateUsername, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }],
        password2: [{ validator: validatePass2, trigger: 'blur' }]
      },
      captchaImg: '', // 验证码图片
      imgCodeLoad: false,
      activeName: 'first',
      isSendCode: false,
      isNumber: 60,
      setIntervalList: null
    }
  },
  created () {
    // this.$nextTick(() => {
    //   this.getImgCodes()
    // })
  },
  methods: {
    test () {
      console.log(123)
    },
    verificationCodeEvent () {
      if (this.formList.mobile.match(/^1[34578]\d{9}$/) === null) {
        this.$message.error('请输入正确的手机号')
        return
      }
      queryMobile({
        'mobile': this.formList.mobile,
        'orgId': sessionStorage.getItem('orgId')
      }).then(res => {
        if (res.code === 0) {
          this.sendCodeEvent()
        }
      })
    },
    sendCodeEvent () {
      this.isSendCode = true
      this.setIntervalList = setInterval(() => {
        this.isNumber--
        if (this.isNumber <= 0) {
          this.isNumber = 60
          clearInterval(this.setIntervalList)
          this.isSendCode = false
        }
      }, 1000)
      // 发送验证码
      // 发送验证码
      if (this.formList.mobile) {
        messageAuthentication({
          mobilePhone: this.formList.mobile,
          orgId: sessionStorage.getItem('orgId'),
          templateId: 'SMS_T_NORMALCODE'
        }).then((res) => {
          if (res.code === 0) {
            this.$message.success('发送成功')
          } else {
            this.$message.error(res.error)
          }
        })
      } else {
        this.$message.error('手机号不能为空')
      }
    },
    loginEvent () {
      this.$refs['formList'].validate((valid) => {
        if (valid) {
          this.formList.orgId = sessionStorage.getItem('orgId')
          if (this.activeName === 'first') {
            userLogin(this.formList).then((res) => {
              if (res.code === 0) {
                this.$message.success('登录成功')
                sessionStorage.setItem('token', res.data.token)
                sessionStorage.setItem('mobile', this.formList.mobile)
                sessionStorage.setItem('loginStatus', 'T')
                this.closeLogin()
                this.$emit('loginOk')
              } else {
                this.$message.error(res.error)
              }
            })
          } else {
            // 手机短信验证码登录
            messageCodeLogin(this.formList).then((res) => {
              if (res.code === 0) {
                this.$message.success('登录成功')
                sessionStorage.setItem('token', res.data.token)
                sessionStorage.setItem('mobile', this.formList.mobile)
                sessionStorage.setItem('loginStatus', 'T')
                this.closeLogin()
                this.$emit('loginOk')
              } else {
                this.$message.error(res.error)
              }
            })
          }
        }
      })
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    closeLogin () {
      this.$refs['formList'].resetFields()
      this.$emit('closeLogin')
    },
    toRegist (i) {
      this.$refs['formList'].resetFields()
      this.$emit('registShowEvent', i)
    },
    backPassword () {
      this.$refs['formList'].resetFields()
      this.$emit('backPassword')
    },
    getImgCodes () {
      getImgCode().then((res) => {
        this.captchaImg = res.data.captchaImg
        this.formList.traceId = res.data.traceId
      })
    },
    refresh () {
      let item = document.getElementsByClassName('refresh1')[0]
      item.style.transform = 'rotate(' + 5 + 'deg)'
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tabs__item.is-active{
  color:rgb(218, 198, 25);
}

.el-tabs__active-bar{
  background-color:rgb(224, 134, 32);
}
.loginPlane {
  position: fixed;
  top: 40%;
  left: 50%;
  display: flex;
  /* transition: trs; */
  transform: translate(-50%, -50%);
  z-index: 2000;
  background: white;
  border: 2px solid #d3d3d3;
  width: 720px;
  // height: 468px;
  border-radius: 16px;
  .left {
    width: 300px;
    height: 468px;
    display: inline-block;
  }
  .curter {
    cursor: pointer;
  }
}
.login {
  width: 390px;
  margin: 60px auto;
  display: inline-block;
  .logo {
    text-align: center;
    margin-bottom: 36px;
  }
  .el-icon-close {
    cursor: pointer;
    position: absolute;
    top: 17px;
    right: 34px;
    font-size: 24px;
  }
  .icon-bk {
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
    background: #853D3F;
    color: white;
  }
  .el-input {
    width: 350px;
  }
  .code-input {
    width: 180px;
  }
  /deep/.el-form-item__content {
    display: flex;
  }
  .rightItem {
    width: 318px;
    display: flex;
    .verificationCode {
      width: 126px;
      height: 38px;
      float: right;
    }
    .verificationCodeBtn {
      margin-left: 5px;
    }
  }
  .refresh {
    cursor: pointer;
    display: inline-block;
    margin-left: 15px;
  }
  .handle {
    width: 390px;
    background: #853D3F;
    color: white;
  }
  .foot-login {
    line-height: 40px;
    height: 40px;
    a {
      color: #c02020;
    }
    .forget-password {
      float: right;
    }
  }
}
.tiketType_box {
  margin-top: 20px;
}
.marquee-title {
  float: left;
  width: 80px;
  line-height: 58px;
  height: 58px;
  margin-right: 18px;
}
.marquee-title span {
  display: inline-block;
  color: #ec2f2f;
  font-size: 12px;
  font-weight: bold;
  vertical-align: middle;
}
.marquee-title img {
  display: inline-block;
  width: 15px;
  height: 18px;
  margin-right: 6px;
  vertical-align: middle;
}
marquee {
  overflow: hidden;
  float: left;
  width: calc(100% - 98px);
  display: block;
  line-height: 58px;
  height: 58px;
  color: #666;
  font-size: 12px;
}

.noticeBtn {
  cursor: pointer;
  float: right;
  line-height: 40px;
  text-align: center;
  background-color: #ffb000;
  padding: 0 15px;
  border-radius: 20px;
  &:hover {
    opacity: 0.8;
  }
  .ico {
    display: inline-block;
    width: 18px;
    height: 20px;
    vertical-align: middle;
    background: url(../assets/images/notice.png) no-repeat;
    background-size: 100% 100%;
    margin-right: 10px;
  }
  .text {
    vertical-align: middle;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
}

.buyticket {
  // margin-bottom: 40px;
  border-radius: 5px;
  .pane {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px 0px rgba(20, 34, 44, 0.15);
    padding: 30px 60px;
    .buyticket-box {
      overflow: hidden;
      .buyticket-div {
        overflow: hidden;
        margin-bottom: 19px;
        .title {
          float: left;
          font-size: 16px;
          color: #333;
          font-weight: bold;
          line-height: 44px;
          height: 44px;
        }
        .buyticket-right {
          overflow: hidden;
          padding-left: 100px;
          // height: 44px;
          .select-list {
            float: right;
            text-align: right;
            > span {
              display: inline-block;
              margin: 0 7px;
              width: 130px;
              height: 44px;
              background: rgba(246, 246, 246, 1);
              border-radius: 6px;
              font-size: 16px;
              color: #333;
              text-align: center;
              line-height: 44px;
              cursor: pointer;
              margin-bottom: 10px;
              > em {
                display: inline-block;
                width: 100%;
                height: 100%;
                line-height: 44px;
                border-radius: 6px;
                overflow: hidden;
                font-style: normal;
                &:hover {
                  opacity: 0.8;
                }
                &.active {
                  background: #241008;
                  color: #fff;
                }
                &.disable {
                  color: #cdcdcd;
                  cursor: no-drop;
                }
              }
            }
          }
          .select-btn {
            float: right;
            width: 130px;
            height: 44px;
            line-height: 44px;
            border-radius: 6px;
            .input-show {
              display: block;
              width: 100%;
              height: 100%;
              line-height: 44px;
              text-align: center;
              height: 44px;
              background: #f6f6f6;
              border-radius: 6px;
              font-size: 16px;
              color: #333;
              text-align: center;
              line-height: 44px;
              cursor: pointer;
              outline: none;
              text-align: center;
              &.active {
                background: #241008;
                color: #fff;
              }
              &:hover {
                opacity: 0.8;
              }
            }
            .picker-options {
              display: block;
              width: 100%;
              height: 44px;
              line-height: 44px;
              .el-input {
                width: 100% !important;
                background: #f6f6f6;
              }
            }
          }
        }
      }
      .buyticket-footer {
        overflow: hidden;
        display: flex;
        border-top: 1px solid #f6f6f6;
        padding-top: 29px;
        margin-top: 31px;
        .booking-notice {
          flex: 1;
          height: 58px;
          line-height: 58px;
          img {
            display: inline-block;
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-right: 4px;
            cursor: pointer;
          }
          span {
            display: inline-block;
            font-size: 16px;
            color: #ec2f2f;
            vertical-align: middle;
            cursor: pointer;
          }
        }
        .booking-msg {
          flex: 1;
          overflow: hidden;
          line-height: 58px;
          text-align: right;
          .msg {
            display: inline-block;
            vertical-align: middle;
            font-size: 16px;
            color: #333;
            span {
              display: inline-block;
              color: #ff4400;
              margin: 0 12px;
            }
          }
          .payBtn {
            display: inline-block;
            width: 140px;
            height: 58px;
            line-height: 58px;
            text-align: center;
            font-size: 18px;
            border-radius: 6px;
            background: #241008;
            color: #fff;
            margin-left: 42px;
            margin-right: 7px;
            cursor: pointer;
            &.disable {
              background: #f6f6f6;
              cursor: no-drop;
              color: #cdcdcd;
            }
            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
    }
    .dateSelect {
      margin-bottom: 16px;
      .label {
        font-weight: bold;
        line-height: 40px;
        margin-right: 15px;
      }
      .btn {
        display: inline-block;
        vertical-align: middle;
        min-width: 60px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin-right: 15px;
        border-radius: 15px;
        cursor: pointer;
        padding: 0 15px;
        box-sizing: border-box;
      }
      .btn.right {
        float: right;
        /* right: 20px; */
      }
      .btn.current {
        color: #fff;
        background-color: #21a4ff;
      }
    }
    .ticketDetail /deep/ .el-table::before {
      height: 0;
    }
    .ticketDetail /deep/ th.is-leaf {
      background-color: #21a4ff;
      color: #fff;
      border-bottom: 12px solid #fff;
    }
    .ticketDetail /deep/ th.is-leaf:nth-child(1) {
      background: url(../assets/images/border_th_l.png) #21a4ff no-repeat left;
    }
    .ticketDetail /deep/ th.is-leaf:nth-last-child(2) {
      background: url(../assets/images/border_th_r.png) #21a4ff no-repeat right;
    }
    .ticketDetail /deep/ td {
      background-color: #f7f7f7;
      border-bottom: 12px solid #fff;
      padding: 10px 0;
    }
    .ticketDetail /deep/ td .cell {
      font-weight: bold;
    }
    .ticketDetail /deep/ td:nth-child(1) {
      background: url(../assets/images/border_td_l.png) #f7f7f7 no-repeat left;
    }
    .ticketDetail /deep/ td:nth-last-child(2) {
      background: url(../assets/images/border_td_r.png) #f7f7f7 no-repeat right;
    }
  }
}

.reserveBtn {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  color: #fff;
  font-weight: bold;
  padding: 0 20px;
  border-radius: 20px;
  background-color: #ffb000;
  cursor: pointer;
}
.reserveBtn:hover {
  background-color: #faab00;
}
.mb40 {
  margin-bottom: 40px;
}
.main-box {
  background: #ededed;
  padding-bottom: 35px;
}
.notice-dialog {
  .title {
    line-height: 20px;
    height: 20px;
    overflow: hidden;
    padding-left: 20px;
    position: relative;
    margin-bottom: 34px;
    &::before {
      position: absolute;
      top: 50%;
      width: 3px;
      height: 14px;
      background: rgba(191, 147, 48, 1);
      border-radius: 2px;
      margin-top: -7px;
      left: 8px;
      content: "";
    }
  }
  .notice {
    display: block;
    min-height: 300px;
    max-height: 400px;
    overflow-y: auto;
  }
  .btn {
    width: 130px;
    height: 44px;
    background: rgba(191, 147, 48, 1);
    border-radius: 6px;
    color: #fff;
    margin: 0 21px;
    &.cancal {
      background: #ccc;
      color: #333;
    }
  }
}
.dialog-login {
  iframe {
    display: block;
    width: 100%;
    height: 400px;
  }
}
</style>
